import { QueryModelCore } from "../core/model.core";
import { getTokenWithoutBearer } from '../core/authUtil';

export default class Menu {
  /**
   * 获取菜单列表
   * @param {number} linkType
   */
  async menuList(linkType = 4) {
    const token = getTokenWithoutBearer();
    const result = await new QueryModelCore('/proxyApi/getMenuInfo').get({ token, linkType });
    const { dataMap } = result;
    return dataMap;
  }
}